import { render, staticRenderFns } from "./SetupBoardSeedModal.vue?vue&type=template&id=50961ea4&scoped=true"
import script from "./SetupBoardSeedModal.vue?vue&type=script&lang=js"
export * from "./SetupBoardSeedModal.vue?vue&type=script&lang=js"
import style0 from "./SetupBoardSeedModal.vue?vue&type=style&index=0&id=50961ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50961ea4",
  null
  
)

export default component.exports